import { Extension } from "@tiptap/core"
import { AllSelection, NodeSelection, Plugin, PluginKey, TextSelection } from "@tiptap/pm/state"

function isEmptyDoc(doc: {
  childCount: number
  firstChild: { type: { name: string }; content: { size: number } } | null
}) {
  return doc.childCount === 1 && doc.firstChild?.type.name === "paragraph" && doc.firstChild.content.size === 0
}

/**
 * После Select All → Delete ProseMirror может оставить NodeSelection/AllSelection
 * на пустом абзаце — тогда «выделяется» первая буква floated-placeholder.
 * Сбрасываем в обычный текстовый caret.
 */
export const EmptyEditorCaret = Extension.create({
  name: "emptyEditorCaret",

  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey("emptyEditorCaret"),
        appendTransaction(_transactions, _oldState, newState) {
          if (!isEmptyDoc(newState.doc)) return null
          const { selection, doc } = newState
          if (!(selection instanceof NodeSelection || selection instanceof AllSelection)) return null
          return newState.tr.setSelection(TextSelection.create(doc, 1))
        },
      }),
    ]
  },
})
